module.exports = __webpack_public_path__ + "img/phone.78f29864.png";